import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { wrapFunctionalComponent } from 'utils/framework';

import {
    Box, Text, Button, Divider, Link
} from 'components/ui';
import localeUtils from 'utils/LanguageLocale';
import Actions from 'Actions';
import UserActions from 'actions/UserActions';
import { colors, space } from 'style/config';
import RegisterEN from 'components/Register/locales/Register_en_US';
import RegisterFR from 'components/Register/locales/Register_fr_CA';
const getText = localeUtils.getLocalisedDataFromResource(RegisterEN, RegisterFR);

const RegisterStoreMember = ({ email, handleSignIn }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        sendEmail(true);
    }, []);

    const sendEmail = (isInitialEmailTrigger = false) => {
        if (!email) {
            dispatch(
                Actions.showInfoModal({
                    isOpen: true,
                    title: getText('errorModalTitle'),
                    message: getText('errorResend'),
                    buttonText: getText('resendButton'),
                    callback: sendEmail,
                    cancelText: getText('okButton'),
                    showCancelButtonLeft: true
                })
            );

            return;
        }

        const token = undefined; // No token for resend email in store member flow

        UserActions.sendVerificationEmail(email, token)
            .then(() => {
                if (!isInitialEmailTrigger) {
                    dispatch(
                        Actions.showInfoModal({
                            isOpen: true,
                            title: getText('successModalTitle'),
                            message: getText('successResend'),
                            buttonText: getText('okButton')
                        })
                    );
                }
            })
            .catch(() => {
                if (!isInitialEmailTrigger) {
                    dispatch(
                        Actions.showInfoModal({
                            isOpen: true,
                            title: getText('errorModalTitle'),
                            message: getText('errorResend'),
                            buttonText: getText('resendButton'),
                            callback: sendEmail,
                            cancelText: getText('okButton'),
                            showCancelButtonLeft: true
                        })
                    );
                }
            });
    };

    const resendEmail = () => {
        sendEmail(false);
    };

    return (
        <Box lineHeight='tight'>
            <Text
                is='h2'
                fontWeight='bold'
                fontSize='xl'
                marginBottom={4}
                children={getText('inStoreMemberTitle')}
            />
            <Text
                is='p'
                marginBottom={4}
                children={`${getText('sentVerificationLink')} ${email}.`}
            />

            <Text
                is='p'
                marginBottom={3}
                fontSize='base'
                lineHeight='base'
                fontWeight='bold'
                children={getText('nextStep')}
            />

            <Box
                is='ol'
                css={{
                    listStyle: 'none',
                    paddingLeft: 0,
                    counterReset: 'step-counter',
                    '& li': {
                        counterIncrement: 'step-counter',
                        position: 'relative',
                        paddingLeft: space[6],
                        '&::before': {
                            content: 'counter(step-counter)',
                            position: 'absolute',
                            left: 0,
                            top: 0,
                            width: 20,
                            height: 20,
                            borderRadius: '50%',
                            backgroundColor: '#eee',
                            color: colors.black,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontWeight: 'bold',
                            fontSize: '14px'
                        }
                    }
                }}
            >
                <Text
                    is='li'
                    marginBottom={2}
                    children={getText('step1')}
                />
                <Text
                    is='li'
                    marginBottom={2}
                    children={getText('step2')}
                />
                <Text
                    is='li'
                    marginBottom={4}
                    children={getText('step3')}
                />
            </Box>
            <Button
                variant='primary'
                width='100%'
                type='button'
                onClick={handleSignIn}
            >
                {getText('gotIt')}
            </Button>
            <Divider
                marginBottom={4}
                marginTop={4}
            />
            <Text marginBottom={4}>
                {getText('emailMissed')}
                <Link
                    onClick={resendEmail}
                    color={colors.blue}
                >
                    {getText('resend')}
                </Link>
            </Text>
        </Box>
    );
};

export default wrapFunctionalComponent(RegisterStoreMember, 'RegisterStoreMember');
